export const GUIDE_CATEGORIES = [
  "clause-explainer",
  "how-to-guide",
  "checklist",
  "comparison",
] as const;

export type GuideCategory = (typeof GUIDE_CATEGORIES)[number];

export const GUIDE_CATEGORY_LABELS: Record<GuideCategory, string> = {
  "clause-explainer": "Clause explainer",
  "how-to-guide": "How-to guide",
  checklist: "Checklist",
  comparison: "Comparison",
};

export const GUIDE_CATEGORY_GRADIENTS: Record<GuideCategory, string> = {
  "clause-explainer": "bg-gradient-to-br from-primary to-[oklch(0.35_0.12_27)]",
  "how-to-guide": "bg-gradient-to-br from-accent to-primary",
  checklist: "bg-gradient-to-br from-[oklch(0.35_0.04_40)] to-accent",
  comparison: "bg-gradient-to-br from-[oklch(0.32_0.08_268)] to-primary",
};

export type GuideFaq = {
  question: string;
  answer: string;
};

export type GuideMeta = {
  title: string;
  slug: string;
  description: string;
  publishDate: string;
  updatedDate: string;
  author: string;
  discipline: string;
  category: GuideCategory;
  tags: string[];
  readTime: number;
  ogImage?: string;
  relatedSlugs: string[];
  faq: GuideFaq[];
};

export type Guide = GuideMeta & {
  html: string;
};

export type RelatedGuideLink = {
  slug: string;
  title: string;
};
